<template>
  <Dialog
    :title="classFormType === 'add' ? '新增课时' : '编辑课时'"
    :visible.sync="chapterDialogVisible"
    width="50%"
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <el-form
      label-width="120px"
      :model="classForm"
      :rules="classFormRules"
      ref="classFormRef"
    >
      <el-form-item label="课时名称：" prop="className">
        <el-input
          maxlength="30"
          v-model.trim="classForm.className"
          auto-complete="off"
          placeholder="请输入名称"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="课时排序：" prop="orderNum">
        <el-input-number
          :min="1"
          :max="100"
          :default="1"
          :step="1"
          :precision="0"
          v-model="classForm.orderNum"
        >
        </el-input-number>
      </el-form-item>
      <el-form-item label="资源上传：" prop="resourceUrl">
        <el-upload
          class="avatar-uploader"
          action=""
          :show-file-list="true"
          :limit="1"
          :file-list="fileList"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :on-exceed="handleExceed"
          accept="video/*"
        >
          <el-button round size="small" type="primary" icon="el-icon-upload"
            >点击上传</el-button
          >
        </el-upload>
      </el-form-item>
      <el-form-item width="100%">
        <el-button plain round size="small" @click="closeDialog"
          >关闭</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="primary"
          :loading="submitLoading"
          @click="submitForm"
        >
          提交
        </el-button>
      </el-form-item>
    </el-form>
  </Dialog>
</template>
<script>
import { uploadFile } from "@/utils/alioss.js";
import {
  addChapterClass,
  updateChapterClass,
  getChapterClassDetail,
  addResource
} from "@/api/course";
export default {
  name: "ClassForm",
  data() {
    const validateClassName = (rule, value, callback) => {
      if (!value) {
        callback();
        return;
      }
      const name = String(value).trim();
      const currentCode = this.classForm.classCode;
      const currentId = this.classForm.classId;
      const duplicated = (this.existingClassList || []).some(item => {
        if (currentCode && item.classCode === currentCode) return false;
        if (currentId && item.classId === currentId) return false;
        return String(item.className || "").trim() === name;
      });
      if (duplicated) {
        callback(new Error("该章节下课时名称不能重复"));
        return;
      }
      callback();
    };
    return {
      classFormType: "",
      chapterDialogVisible: false,
      existingClassList: [],
      // 课时
      classForm: {
        orderNum: 1,
        className: "",
        resourceUrl: ""
      },
      // addResource 入参：urls 为完整访问地址（含域名）
      fileForm: {
        fileName: "",
        resourceName: "",
        resourceType: 1,
        urls: "",
        duration: 0
      },
      fileList: [],
      fileChanged: false,
      classFormRules: {
        className: [
          { required: true, message: "请输入课时名称", trigger: "blur" },
          { validator: validateClassName, trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "请输入课时排序", trigger: "blur" }
        ],
        resourceUrl: [
          { required: true, message: "请上传课时资源", trigger: "change" }
        ]
      },
      submitLoading: false
    };
  },
  methods: {
    getUploadedFileName(uploadResult, resourceUrl, fallbackName = "") {
      const ossKey = (uploadResult && uploadResult.name) || "";
      if (ossKey) {
        return ossKey
          .split("/")
          .filter(Boolean)
          .pop();
      }
      if (resourceUrl) {
        return resourceUrl
          .split("/")
          .filter(Boolean)
          .pop();
      }
      return fallbackName;
    },

    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.classFormRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      try {
        const shouldCreateResource =
          this.classFormType === "add" || this.fileChanged;
        if (shouldCreateResource) {
          // addResource：urls 传完整访问地址（含域名）
          const res = await addResource({
            fileName: this.fileForm.fileName,
            resourceName: this.fileForm.resourceName,
            resourceType: this.fileForm.resourceType,
            urls: this.fileForm.urls,
            duration: this.fileForm.duration
          });
          this.classForm.resourceCode = res.data;
          this.classForm.resourceType = 1;
          this.classForm.classTime = this.fileForm.duration;
          this.classForm.fileName = this.fileForm.fileName;
          this.classForm.resourceName = this.fileForm.resourceName;
        }
        if (this.classFormType === "add") {
          await addChapterClass({
            ...this.classForm,
            courseCode: this.courseCode
          });
          this.$message.success("新增成功");
        } else {
          const payload = {
            ...this.classForm,
            courseCode: this.courseCode
          };
          // 更换视频后，防刷课时间点失效，需关闭并清空题目
          if (this.fileChanged) {
            payload.antiBrushStatus = 0;
            payload.questionJson = "[]";
          }
          await updateChapterClass(payload);
          this.$message.success("修改成功");
        }
        this.$emit("success", this.classForm.chapterCode);
        this.closeDialog();
      } finally {
        this.submitLoading = false;
      }
    },
    handleSuccess(res, file) {
      console.log(res);
    },
    validateResourceUrl() {
      this.$nextTick(() => {
        this.$refs.classFormRef &&
          this.$refs.classFormRef.validateField("resourceUrl");
      });
    },
    handleRemove() {
      this.fileList = [];
      this.fileChanged = true;
      this.classForm.resourceUrl = "";
      this.classForm.fileName = "";
      this.classForm.resourceName = "";
      this.fileForm = {
        fileName: "",
        resourceName: "",
        resourceType: 1,
        urls: "",
        duration: 0
      };
      this.validateResourceUrl();
    },
    // 已有文件时再次选择，覆盖原文件
    handleExceed(files) {
      const file = files && files[0];
      if (!file) return;
      this.fileList = [];
      this.beforeUpload(file);
    },
    getVideoDuration(file) {
      return new Promise(resolve => {
        const url = URL.createObjectURL(file);
        const video = document.createElement("video");
        video.preload = "metadata"; // 仅预加载元数据，不下载整个视频

        video.onloadedmetadata = () => {
          URL.revokeObjectURL(url); // 释放内存
          resolve(video.duration); // 返回时长（秒）
        };

        video.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(0); // 发生错误时返回 0
        };

        video.src = url;
      });
    },
    beforeUpload(file) {
      const isVideo = file.type.startsWith("video/");
      if (!isVideo) {
        this.$message.error("仅支持视频文件！");
        return false;
      }
      this.handleVideoUpload(file);
      return false;
    },
    async handleVideoUpload(file) {
      try {
        const duration = await this.getVideoDuration(file);
        const uploadResult = await uploadFile("video", file, file.name);
        const resourceUrl =
          (uploadResult && uploadResult.url) ||
          (uploadResult &&
            uploadResult.res &&
            uploadResult.res.requestUrls &&
            uploadResult.res.requestUrls[0]);
        if (!resourceUrl) {
          this.$message.error("上传失败，请重试");
          return;
        }
        const uploadedFileName = this.getUploadedFileName(
          uploadResult,
          resourceUrl,
          file.name
        );
        this.fileChanged = true;
        this.fileForm = {
          fileName: uploadedFileName,
          resourceName: uploadedFileName,
          resourceType: 1,
          // addResource.urls：完整访问地址（含域名）
          urls: resourceUrl,
          duration
        };
        this.fileList = [
          {
            name: uploadedFileName,
            url: resourceUrl
          }
        ];
        this.classForm.fileName = uploadedFileName;
        this.classForm.resourceName = uploadedFileName;
        this.classForm.resourceUrl = resourceUrl;
        this.validateResourceUrl();
      } catch (error) {
        console.log(error);
        this.$message.error("上传失败，请重试");
      }
    },
    async open(type, row = {}, existingList = []) {
      this.classFormType = type;
      this.fileChanged = false;
      this.existingClassList = Array.isArray(existingList) ? existingList : [];
      if (type == "edit") {
        const res = await getChapterClassDetail(row.classId);
        const data = res.data || {};
        const resourceUrl = data.resourceUrl || data.urls || "";
        this.classForm = {
          ...data,
          resourceUrl
        };
        this.fileForm = {
          fileName: data.fileName || "",
          resourceName: data.resourceName || "",
          resourceType: 1,
          // 编辑未换文件时不会调 addResource；保留完整地址
          urls: resourceUrl,
          duration: Number(data.classTime) || 0
        };
        const displayName =
          data.fileName ||
          (resourceUrl
            ? resourceUrl
                .split("/")
                .filter(Boolean)
                .pop()
            : "");
        this.fileList = resourceUrl
          ? [
              {
                name: displayName,
                url: resourceUrl
              }
            ]
          : [];
      } else {
        this.classForm = {
          orderNum: 1,
          className: "",
          resourceUrl: "",
          ...row
        };
        this.fileForm = {
          fileName: "",
          resourceName: "",
          resourceType: 1,
          urls: "",
          duration: 0
        };
        this.fileList = [];
      }
      this.chapterDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.classFormRef && this.$refs.classFormRef.clearValidate();
      });
    },
    closeDialog() {
      this.$refs.classFormRef && this.$refs.classFormRef.resetFields();
      this.fileList = [];
      this.fileChanged = false;
      this.existingClassList = [];
      this.classForm = {
        orderNum: 1,
        className: "",
        resourceUrl: ""
      };
      this.fileForm = {
        fileName: "",
        resourceName: "",
        resourceType: 1,
        urls: "",
        duration: 0
      };
      this.chapterDialogVisible = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/CourseEdit/components/ClassForm.vue